import * as angular from 'angular';

export class StatesDataService {
  static $inject = ['$http'];
  constructor(private $http: angular.IHttpService) {}

  getStatesByCountry(country: string): angular.IPromise<any> {
    const config = {
      params: {
        country: country,
      },
    };
    return this.$http
      .get('/states', config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return [];
      });
  }
}
